export const EVENTS = {
    WEB_ASSESMENT_SHOWN: "Web Assessment Shown",
    ASSESSMENT_PAGE_SHOWN: "Assessment Page Shown",
    ASSESSMENT_PARTIAL_EVALUATION: "Assessment Partial Evaluation",
    ENRICHMENT_SCREEN_SHOWN: "Enrichment Screen Shown",
    ASSESSMENT_SKIP_CTA_CLICK: "Assessment Skip CTA Click",
    ASSESSMENT_ANSWERED: "Assessment Answered",
    ASSESSMENT_QUESTION_SHOWN: "Assessment Question Shown",
    ASSESSMENT_BACKPRESS: "Assessment Backpress",
}
export const AUDIO_ASSESSMENT_EVENTS = {
    ENGLISH_AUDIO_INTRO_RECORDING_STARTED: "english_audio_intro_recording_started",
    ENGLISH_AUDIO_INTRO_RECORD_AGAIN_CLICKED: "english_audio_intro_record_again_clicked",
    ENGLISH_AUDIO_INTRO_RECORDING_STOPPED: "english_audio_intro_recording_stopped",
    ENGLISH_AUDIO_INTRO_RECORED_PLAYED: "english_audio_intro_recorded_played",
    ENGLISH_AUDIO_INTRO_RECORDED_PAUSED: "english_audio_intro_recorded_paused",
    ENGLISH_AUDIO_INTRO_UPLOAD_CLICKED: "english_audio_intro_upload_clicked",
    ENGLISH_AUDIO_INTRO_UPLOAD_RESULT: "english_audio_intro_upload_result",
    SPOKEN_ENGLISH_TEST: "spoken_english_test",
}
export const ASSESSMENTS_EVENTS = {
    UPLOAD_DOCUMENT_CTA_CLICKED: "Upload Document CTA Clicked",
    ADD_DOCUMENT_CLICKED: "Add Document Clicked",
    DOCUMENT_REMOVED: "Document Removed",
    DOCUMENT_UPLOAD_INITIATED: "Document Upload Initiated",
    DOCUMENT_UPLOAD_SUCCESS: "Document Upload Success",
    DOCUMENT_UPLOAD_FAILURE: "Document Upload Failure",
    ASSESSMENT_RESULT: "Assessment Result",
}
export const JOB_PREFERENCE_EVENTS = {
    JOB_PREFERENCE_SELECTED: "Job Preference Selected",
    JOB_PREFERENCE_NO_SELECTION_ERROR: "Job Preference No Selected Error",
}
export const ASSET_ASSESSMENT_EVENTS = {
    SAVE_CLICK: "Post assessement  save button clicked",
    ANSWERED: "Post assessement questions answered",
}
